import ButtonParameters from "../../IButtonParameters";

export default class IconParameters extends ButtonParameters {
    private _icon: string;
    private _tooltip: string;

    public constructor(right: string, datas?: any) {
        super(right, datas);
        this._icon = datas?.icon ?? "square";
        this._tooltip = datas?.tooltip ?? "Tooltip non défini";
    }

    /** icon à employer */
    public get Icon(): string {
        return this._icon;
    }

    /** Message du tooltip */
    public get Tooltip(): string {
        return this._tooltip;
    }
}

export class Empty extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'square-fill', tooltip: 'Bouton vide'});
    }
}

export class Edit extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Write'), {icon: 'pencil-fill', tooltip: 'Edit'});
    }
}

export class Delete extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Delete'), {icon: 'x', tooltip: 'Delete'});
    }
}

export class Add extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Add'), {icon: 'plus', tooltip: 'Add'});
    }
}

export class Publish extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Write'), {icon: 'check', tooltip: 'Publish'});
    }
}

export class Archive extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Write'), {icon: 'box-arrow-up-right', tooltip: 'Archive'});
    }
}

export class Erase extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Write'), {icon: 'eraser', tooltip: 'Erase'});
    }
}

export class SelectAll extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'check2-all', tooltip: 'SelectAll'});
    }
}

export class Excel extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'file-earmark-excel', tooltip: 'ExcelExport'});
    }
}

export class Cancel extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'slash-circle', tooltip: 'Cancel'});
    }
}

export class Close extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'x-lg', tooltip: 'Close'});
    }
}

export class Link extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Write'), {icon: 'link-45deg', tooltip: 'Link'});
    }
}

export class Mail extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Write'), {icon: 'envelope-fill', tooltip: 'SendMail'});
    }
}

export class Search extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'search', tooltip: 'Search'});
    }
}

export class Expand extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'arrows-expand', tooltip: 'Expand'});
    }
}

export class Collapse extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'arrows-collapse', tooltip: 'Collapse'});
    }
}

export class Download extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Read'), {icon: 'download', tooltip: 'Download'});
    }
}

export class Sign extends IconParameters {
    public constructor(right) {
        super(IconParameters.GetRight(right, 'Delete'), {icon: 'file-check', tooltip: 'Sign'})
    }
}

// Liste de tous les types de bouton possible.
export const ButtonActionEnum: { [key: string]: typeof ButtonParameters } = {
    Empty: Empty,
    Edit: Edit,
    Delete: Delete,
    Add: Add,
    Publish: Publish,
    Archive: Archive,
    Erase: Erase,
    SelectAll: SelectAll,
    Excel: Excel,
    Cancel: Cancel,
    Close: Close,
    Link: Link,
    Mail: Mail,
    Search: Search,
    Expand: Expand,
    Collapse: Collapse,
    Download: Download,
    Sign: Sign,
}